import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import { openLogIn, openSignUp } from './authModals';
// Absent unless the CTA is switched on. See ForumAttributes.php.
const position = () => app.forum.attribute('guestCtaPosition');

/**
 * @param key Needed wherever the CTA sits among the stream's own items, which
 *   are keyed. Left out inside `afterFirstPostItems`, whose items are not.
 */
const cta = key => {
  // A forum that has closed registration has nothing to offer but logging in.
  const signUp = app.forum.attribute('allowSignUp');
  return m("div", {
    className: "PostStream-item PostStream-guestCta",
    key: key
  }, m("div", {
    className: "GuestCta-wrapper"
  }, m("div", {
    className: "GuestCta"
  }, m("span", {
    className: "GuestCta-text"
  }, app.forum.attribute('guestCtaText') || app.translator.trans('ramon-guest-cta.forum.post_cta.text')), m("span", {
    className: "GuestCta-buttons"
  }, m(Button, {
    className: "Button Button--primary GuestCta-btn GuestCta-btn--login",
    icon: "fas fa-sign-in-alt",
    onclick: openLogIn
  }, app.translator.trans('core.forum.header.log_in_link')), signUp && m("span", {
    className: "GuestCta-or"
  }, app.translator.trans('ramon-guest-cta.forum.post_cta.or')), signUp && m(Button, {
    className: "Button GuestCta-btn GuestCta-btn--signup",
    icon: "fas fa-user-plus",
    onclick: openSignUp
  }, app.translator.trans('core.forum.header.sign_up_link'))))));
};

/**
 * Where in the stream's items the CTA goes, or -1 if it does not belong in
 * what is on screen right now.
 */
function indexFor(stream, items, position) {
  if (position === 'end') {
    if (!stream.viewingEnd()) return -1;

    // Ahead of the reply placeholder, which closes the stream.
    const reply = items.findIndex(item => item?.key === 'reply');
    return reply === -1 ? items.length : reply;
  }

  // "After post #3" means the discussion's third post, not the third one that
  // happens to be loaded for a reader who landed in the middle.
  if (stream.visibleStart !== 0) return -1;

  // Event posts (stickied, locked, renamed…) carry a different data-type and
  // must not advance the counter — the setting refers to comment posts only.
  let seen = 0;
  const target = Number(position);
  const post = items.findIndex(item => item?.attrs?.['data-type'] === 'comment' && ++seen === target);
  return post === -1 ? -1 : post + 1;
}
export default function addPostStreamCta() {
  // PostStream is code-split — use the string-based extend so flarum.reg.onLoad
  // applies the patch when the chunk evaluates. Same pattern flarum/realtime uses.

  // Position 1: afterFirstPostItems — Flarum-native hook, fully Mithril-managed.
  extend('flarum/forum/components/PostStream', 'afterFirstPostItems', function (items) {
    if (position() === '1') items.add('guest-cta', cta(), 100);
  });

  // Everywhere else: splice the CTA in among the rendered items.
  extend('flarum/forum/components/PostStream', 'view', function (vnode) {
    const where = position();
    if (!where || where === '1' || !Array.isArray(vnode.children)) return;
    const items = vnode.children;
    const index = indexFor(this.stream, items, where);
    if (index !== -1) items.splice(index, 0, cta('guest-cta'));
  });
}